// 韩语
export default {
    login: {
        t01: '언어',
        t02: 'Netflix',
        t03: '사용자 이름을 입력하세요',
        t04: '비밀번호를 입력하세요',
        t05: '로그인',
        t06: '회원가입',
        t07: '전화 번호를 입력하세요',
        t08: '비밀번호 확인',
        t09: '초대 코드를 입력하세요',
        t10: '계정 등록',
        t11: '비밀번호 확인',
        t13: '영화에 대한 사랑은 당신도 모르는 사이에 풍부한 부를 쌓게 해줄 수 있습니다.',
        t14: '로그인 성공',
        t15: '비밀번호가 일치하지 않습니다',
        t16: '회원가입 성공',
        t17: '네트워크 오류',
        t18: '요청 시간 초과, 연결을 확인하세요'
    },
    cover_info: {
        t01: '이익 시작하기',
        t02: '코인 충전',
        t03: '코인 인출',
        t04: '증서'
    },
    cont: {
        t01: '언어 선택',
        t02: '모두',
        t03: '대기 중',
        t04: '완료됨',
        t05: '결속 중',
        t06: '나의 잔액',
        t07: '미완료',
        t08: '총 주문 금액',
        t09: '수익',
        t10: '수익 획득',
        t11: '주문 수량',
        t12: '사용 가능 잔액',
        t13: '주문 시작',
        t14: '계정 자금',
        t15: '주문 전송',
        t16: '모든 주문 전송',
        t17: '주문 취득 시간',
        t18: '주문 번호',
        t19: '주문 총 금액',
        t21: '작품',
        t22: '배우',
        t23: '작품 댓글',
        t24: '취소',
        t25: '평가를 선택하세요',
        t26: '주문 전송이 완료되었습니다',
        t27: '주문 취득',
        t28: '주문 취득 성공',
        t29: '주문 취득에 실패했습니다. 다시 시도해주세요'
    }
    ,
    user: {
        t1: '추천코드',
        t2: '잔액',
        t3: '가용 잔액',
        t4: '총 수익',
        t5: '출금',
        t6: '입금 기록',
        t7: '출금 기록',
        t8: '계정 세부 정보',
        t9: '메시지',
        t10: '은행 카드 연결',
        t11: '비밀번호 변경',
        t12: '출금 비밀번호 변경',
        t13: '친구 초대',
        t14: '언어 선택',
        t15: '로그아웃',
        t16: '출금',
        t17: '출금할 금액',
        t18: '계정 이름',
        t19: '전화 번호',
        t20: '출금할 금액',
        t21: '출금',
        t22: '출금할 금액을 입력하세요',
        t23: '자금 비밀번호를 입력하십시오',
        t24: '입금 총액',
        t25: '시스템 메시지',
        t26: '은행 카드 세부 정보',
        t27: '은행 목록',
        t28: '은행 이름',
        t29: '성',
        t30: '은행 카드 번호',
        t31: '전화 번호',
        t32: '변경 사항 확인',
        t33: '연결한 은행 카드의 계정 번호와 IFSC 번호를 입력하십시오. 동시에 성함과 전화번호를 올바르게 기입해야 합니다. 그렇지 않으면 입금액이 도착하지 않습니다.',
        t34: '이전 비밀번호',
        t35: '새로운 비밀번호',
        t36: '비밀번호 확인',
        t37: '계속하기',
        t38: '비밀번호를 기억해 주세요. 만약 비밀번호를 잊으셨다면 고객 서비스에 연락하십시오.',
        t39: '초대 링크 복사',
        t40: '수익을 위해 친구들을 초대하세요',
        t41: '입금하기',
        t42: '확인',
        t43: '취소',
        t44: '로그아웃 하시겠습니까?',
        t45: '입금액',
        t46: '성공적으로 입금됨',
        t47: '검증 완료',
        t48: '검증 대기 중',
        t49: '총 출금액',
        t50: '출금 비밀번호를 먼저 설정하세요',
        t51: '이전 비밀번호를 입력하십시오',
        t52: '새로운 비밀번호를 입력하십시오',
        t53: '비밀번호 확인을 입력하십시오',
        t54: '입력한 두 개의 비밀번호가 일치하지 않습니다',
        t55: '복사됨',
        t56: '출금액은 30보다 작을 수 없습니다',
        t57: '성공적으로 보냈습니다. 리디렉션 중',
        t58: '검토 실패',
        t59: '프로필 사진 설정',
        t60: '지금 설정',
        t61: '성공적으로 설정됨',
        t62: '지갑 승인이 완료되면 로그인하여 돈을 인출해야 합니다',
        t63: '은행 계좌로 출금',
        t64: 'USDT로 출금 (비율 1:0.013)',
        t65: '은행 계좌 번호',
        t66: '바인딩하려는 은행 카드의 계좌번호와 IFSC 코드를 입력해주세요. 그리고 성명과 모바일 전화번호를 정확하게 입력해주시기 바랍니다. 모든 정보가 정확해야 결제 처리가 원활합니다.',
        t67: '먼저 은행 카드를 연결해주세요',
        t68: '사용자 충전',
        t69: '사용자 주문 수락',
        t70: '하위 커미션',
        t71: '사용자 출금',
        t72: '예바오로 이체',
        t73: '예바오에서 이체',
        t74: '예바오 수익',
        t75: '주문 커미션',
        t76: '잔액이 30 미만, 거래를 계속할 수 없습니다. 고객 서비스에 문의해주세요',
        t77: '은행 이름을 입력하세요',
        t78: '은행 계좌 번호를 입력하세요',
        t80: '실명을 입력하세요',
        t81: '전화 번호를 입력하세요',
        t82: '출금액을 입력하세요',
        t83: '복사',
        t84: '오늘의 TOP 100: 글로벌',
        t85: '듣다',
        t86: "이메일",
        t87: "이메일을 입력해주세요",
        "t88": "은행 코드",
        "t89": "은행 코드를 입력해주세요",
        t90: '은행 송금',
        t91: '1. 출금 수수료는 부과되지 않습니다',
        t92: '2. 출금 후 10~15분 이내에 정상적으로 입금됩니다. 영업시간 이후 출금은 다음 영업시간에 처리됩니다.'
    },
    movie: {
        t01: '인기 영화 및 TV 프로그램',
        t02: '자금 비밀번호',
        t03: '주문 차액',
        t04: '온체인 주소 관리',
        t05: '입력해 주세요',
        t06: '올바른 온체인 주소와 해당 네트워크(예: ERC20/TRC20/BTC)를 입력해 주세요. 그렇지 않으면 결제/전송이 도착하지 않거나 자산 손실이 발생할 수 있습니다.',
        t07: '온체인 주소로 출금',
        t08: '추가해 주세요',
        t09: '온체인 주소를 추가해 주세요',
    },
    langType: '韩语'
}
